'use client';

import { useQuery } from '@tanstack/react-query';

import { hometownNewsQueryOptions } from '@/query-factory';
import { useAuthStore } from '@/stores/AuthStore';

interface HometownNewsDaysAgoProps {
  fallbackDate: string;
  id: number;
}

export const HometownNewsDaysAgo = ({
  fallbackDate,
  id,
}: HometownNewsDaysAgoProps) => {
  const isLogin = useAuthStore((state) => state.isLogin);
  const feedback = useQuery({
    ...hometownNewsQueryOptions.feedback({
      id,
      isLogin,
    }),
    select: ({ context }) => ({
      daysAgo: context?.days_ago,
    }),
  });

  const { daysAgo: clientDaysAgo } = feedback.data ?? {};
  const daysAgo = clientDaysAgo ?? fallbackDate;

  return <p className="text-Gray-700 typo-caption1">{daysAgo}</p>;
};
